import { useCurrentSubscriptionApi } from '@aibees/shared/features/price-and-plan/api/use-current-subscription-api';
import { classnames, fDate } from '@aibees/shared/utils';
import { Stack, Typography } from '@mui/material';
import { memo } from 'react';
import { usePlanCardContext } from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { UpcomingPlanBadgeProps as Props } from './types';
import { Chip } from '@aibees/shared/components';

export const UpcomingPlanBadge = memo(({ className }: Props) => {
  const { data } = useCurrentSubscriptionApi();
  const { selectedPlan } = usePlanCardContext();

  const nextPlan = data?.next;

  if (!nextPlan || selectedPlan?.id !== nextPlan?.plan?.id) return null;

  return (
    <Stack>
      <Styled.Wrapper
        className={classnames('UpcomingPlanBadge', className)}
        sx={SX.root}
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        flexWrap="nowrap"
        gap={1}
      >
        <Stack>
          <Typography variant="body5" color="warning.700" fontWeight={400}>
            Effective on {fDate(nextPlan?.startDate, 'dd/MM/yy')}
          </Typography>
          <Typography variant="body5" color="warning.700" fontWeight={700}>
            {nextPlan?.plan?.metadata.request}
            {' / '}
            {nextPlan.plan?.interval === 'MONTH' ? 'Monthly' : 'Yearly'}
          </Typography>
        </Stack>
        <Chip label="Upcoming" color="warning" variant="filled" />
      </Styled.Wrapper>
    </Stack>
  );
});

UpcomingPlanBadge.displayName = 'UpcomingPlanBadge';
